import { render, staticRenderFns } from "./assuntoCliente.vue?vue&type=template&id=732d3938"
import script from "./assuntoCliente.vue?vue&type=script&lang=js"
export * from "./assuntoCliente.vue?vue&type=script&lang=js"
import style0 from "./assuntoCliente.vue?vue&type=style&index=0&id=732d3938&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports